export const FORMA_PAGO = {
  NINGUNA: 0,
  EFECTIVO: 1,
  PAGO_DOMICILIADO: 2,
  TEF: 3,
  TRANSFERENCIA: 4,
  MONEDERO_ELECTRONICO: 5,
  DINERO_ELECTRONICO: 6,
  VALE_DESPENDA: 7,
  DACION_PAGO: 8,
  PAGO_SUBROGACION: 9,
  PAGO_CONSIGNACION: 10,
  CONDONACION: 11,
  COMPENSACION: 12,
  NOVACION: 13,
  CONFUSION: 14,
  REMISION_DEUDA: 15,
  PRESCRIPCION_O_CADUCIDAD: 16,
  A_SATISFACION_ACREEDOR: 17,
  TARJETA_DEBITO: 18,
  TARJETA_SERVICIOS: 19,
  CONFIRMING: 20,
  PAGARE: 21,
} as const

export type FormaPagoType = (typeof FORMA_PAGO)[keyof typeof FORMA_PAGO]
